import { readStaffDirectory } from "./staffDirectoryRead";
// Keep the full administrative directory; filter only human-agent consumers.
export function fetchSrmUsers({ force = false, strict = false } = {}) {
  return readStaffDirectory({ force }).then(res => {
    if (!res.data?.success || !Array.isArray(res.data.data)) throw new Error("Could not refresh agent eligibility.");
    const users = res.data.data.map(u => ({
      id: u.id,
      fullName: [u.name, u.surname].filter(Boolean).join(" ").trim() || u.username,
      pfp: u.pfp || null,
      account_kind: u.account_kind,
      watiId: u.wati_id || null,
      is_messaging_service_account: u.is_messaging_service_account === true,
      is_online: u.is_online === true,
    })).sort((a, b) => a.fullName.localeCompare(b.fullName));
    return users;
  }).catch(error => { if (strict) throw error; return []; });
}
